var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warehouse",
    transform: "translate(-21 -288.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3006",
    "data-name": "Group 3006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3005",
    "data-name": "Group 3005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3004",
    "data-name": "Group 3004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3003",
    "data-name": "Group 3003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3002",
    "data-name": "Group 3002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3001",
    "data-name": "Group 3001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3000",
    "data-name": "Group 3000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2999",
    "data-name": "Group 2999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-warehouse",
    "data-name": "Icon awesome-warehouse",
    d: "M17.325,12.1H4.689a.276.276,0,0,0-.275.275l0,1.65a.276.276,0,0,0,.275.275h12.64a.276.276,0,0,0,.275-.275v-1.65A.276.276,0,0,0,17.325,12.1Zm0,3.3H4.678a.276.276,0,0,0-.275.275l0,1.65a.276.276,0,0,0,.275.275h12.65a.276.276,0,0,0,.275-.275v-1.65A.276.276,0,0,0,17.325,15.4Zm0-6.6H4.7a.276.276,0,0,0-.275.275l0,1.65A.276.276,0,0,0,4.692,11H17.325a.276.276,0,0,0,.275-.275V9.076A.276.276,0,0,0,17.325,8.8Zm3.661-4.778L11.633.128a1.655,1.655,0,0,0-1.268,0L1.014,4.023A1.654,1.654,0,0,0,0,5.546v11.78a.276.276,0,0,0,.275.275h2.75a.276.276,0,0,0,.275-.275V8.8A1.112,1.112,0,0,1,4.421,7.7H17.579A1.112,1.112,0,0,1,18.7,8.8v8.525a.276.276,0,0,0,.275.275h2.75A.276.276,0,0,0,22,17.326V5.546A1.654,1.654,0,0,0,20.986,4.023Z",
    transform: "translate(25 294.498)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    width: 30,
    height: 30,
    transform: "translate(21 288.5)",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.2273efe51c09e510e234e219a944c328.svg";
export { ForwardRef as ReactComponent };